import Card from 'antd/es/card';
import Radio from 'antd/es/radio';
import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;

  .ant-radio-button-wrapper {
    flex: 1;
    text-align: center;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
`;

export const TemplatePreview = styled.div`
  border: 1px solid ${({ theme }) => theme.token.colorBorderSecondary};
  border-radius: ${({ theme }) => `${theme.token.borderRadiusLG}px`};
  padding: 16px;
  background-color: ${({ theme }) => theme.token.colorBgLayout};
  white-space: pre-wrap;

  .hbs-expression {
    color: ${({ theme }) => theme.token.colorPrimary};
    font-weight: 500;
  }

  .hbs-block {
    color: ${({ theme }) => theme.token.colorWarning};
    font-weight: 500;
  }
`;

export const TemplateFields = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const FieldsHeader = styled.h3`
  margin-bottom: 16px;
  font-size: ${({ theme }) => `${theme.token.fontSizeLG}px`};
  font-weight: 500;
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.token.colorBgContainer};
  z-index: 1;
  padding-top: ${({ theme }) => `${theme.token.paddingXS}px`};
`;

// Components moved from CreateTaskForm.tsx
export const StyledFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  gap: ${({ theme }) => `${theme.token.marginMD}px`};
  /* Fixed overall height for consistent layout */
  height: 500px;
`;

export const StepsContainer = styled.div`
  width: calc(100% - 150px);
  padding-bottom: ${({ theme }) => `${theme.token.paddingXS}px`};

  align-self: center;

  .ant-steps-item-disabled {
    opacity: 0.5;

    .ant-steps-item-container::after {
      background-color: ${({ theme }) =>
        `${theme.token.colorBorderSecondary}!important`};
      border-style: dashed !important;
    }

    .ant-steps-item-icon {
      border-style: dashed;
      background-color: ${({ theme }) => theme.token.colorBgContainer};

      .ant-steps-icon {
        color: ${({ theme }) => theme.token.colorTextDisabled};
      }
    }
  }
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 380px; /* Fixed height for consistent layout */
  padding: ${({ theme }) => `${theme.token.paddingXS}px`};
  /* Allow child components to control their own scrolling, but prevent layout shifts */
  overflow-y: auto;
  overflow-x: hidden;
`;

export const StepActions = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: ${({ theme }) => `${theme.token.marginSM}px`};
  padding-top: ${({ theme }) => `${theme.token.paddingSM}px`};
  border-top: 1px solid ${({ theme }) => theme.token.colorBorderSecondary};

  & > button:last-child {
    margin-left: auto;
  }
`;

export const OptionCard = styled(Card)`
  height: 200px; /* Reduced height */
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: visible;

  &:hover {
    box-shadow: ${({ theme }) => theme.token.boxShadowSecondary};
  }

  &.selected {
    border-color: ${({ theme }) => theme.token.colorPrimary};
    box-shadow: 0 0 0 2px ${({ theme }) => `${theme.token.colorPrimary}20`};

    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 2px solid ${({ theme }) => theme.token.colorPrimary};
      border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
      pointer-events: none;
    }
  }
`;

export const OptionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
`;

export const OptionTitle = styled.h3`
  margin-bottom: 16px;
  font-size: ${({ theme }) => theme.token.fontSizeLG}px;
  font-weight: 500;
`;

export const OptionDescription = styled.p`
  color: ${({ theme }) => theme.token.colorTextSecondary};
`;

export const FieldsScrollContainer = styled.div`
  /* Allow full height use while letting content be scrollable internally */
  height: 100%;
  display: flex;
  flex-direction: column;
`;

// New components for the simple preview
export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PreviewSection = styled.div`
  margin-bottom: 16px;
`;

export const PreviewTitle = styled.h4`
  font-size: ${({ theme }) => theme.token.fontSize}px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const SimplePreview = styled.div`
  border: 1px solid ${({ theme }) => theme.token.colorBorderSecondary};
  border-radius: ${({ theme }) => `${theme.token.borderRadiusLG}px`};
  padding: 16px;
  background-color: ${({ theme }) => theme.token.colorBgLayout};
  white-space: pre-wrap;
  max-height: 250px;
  overflow-y: auto;
`;
